import * as React from 'react';

import { requestPut } from '../../../../../modules/request/index';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const CloseUnitModal = ({ onSuccess, closeModal, unitId, unitName, notice = null, additionalUnitIds = [], onFailure = null, closedViewName = 'My Closed Activity Packs', }) => {
  const { modalRef } = useModalAccessibility(closeModal);

  function handleCloseUnitButtonClick() {
    const unitIds = [unitId, ...additionalUnitIds]
    let remaining = unitIds.length
    let anyFailed = false
    const settle = (failed: boolean) => {
      anyFailed = anyFailed || failed
      remaining -= 1
      if (remaining > 0) { return }
      anyFailed ? onFailure() : onSuccess('Activity pack closed')
    }
    unitIds.forEach(id => {
      const request = requestPut(`/teachers/units/${id}/close`, {}, () => settle(false), onFailure ? () => settle(true) : undefined)
      if (onFailure) { request?.catch?.(() => settle(true)) }
    })
  }

  return (
    <div className="modal-container archive-activity-pack-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="archiveActivityPackModalTitle"
        aria-modal="true"
        className="archive-activity-pack-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="archiveActivityPackModalTitle">Close this activity pack?</h3>
        </div>
        <div className="archive-activity-pack-modal-text">
          {notice}
          <p>This activity pack will move to the &#34;{closedViewName}&#34; tab. You will still have access to it in your student reports.</p>
          <p>Activities that students did not complete will be removed from their &#34;To-do activities&#34; list. Activities that students completed will remain on their &#34;Completed&#34; list.</p>
          <p>If you change your mind and wish to reopen this activity pack, you can do so from the &#34;{closedViewName}&#34; tab.</p>
        </div>
        <div className="form-buttons">
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button contained medium green focus-on-light" onClick={handleCloseUnitButtonClick} type="button">Close pack</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default CloseUnitModal
